var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneForwarded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_3336",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_3336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6375 12.2498C10.4222 12.2498 9.22153 11.9849 8.03542 11.455C6.84931 10.9252 5.77014 10.1741 4.79792 9.20192C3.82569 8.2297 3.07465 7.15053 2.54479 5.96442C2.01493 4.77831 1.75 3.57762 1.75 2.36234C1.75 2.18734 1.80833 2.0415 1.925 1.92484C2.04167 1.80817 2.1875 1.74984 2.3625 1.74984H4.725C4.86111 1.74984 4.98264 1.79602 5.08958 1.88838C5.19653 1.98074 5.25972 2.09012 5.27917 2.2165L5.65833 4.25817C5.67778 4.41373 5.67292 4.54498 5.64375 4.65192C5.61458 4.75886 5.56111 4.85123 5.48333 4.929L4.06875 6.35817C4.26319 6.71789 4.4941 7.06546 4.76146 7.40088C5.02882 7.7363 5.32292 8.05956 5.64375 8.37067C5.94514 8.67206 6.26111 8.95157 6.59167 9.20921C6.92222 9.46685 7.27222 9.70261 7.64167 9.9165L9.0125 8.54567C9.1 8.45817 9.21424 8.39255 9.35521 8.3488C9.49618 8.30505 9.63472 8.29289 9.77083 8.31234L11.7833 8.72067C11.9194 8.75956 12.0312 8.83005 12.1187 8.93213C12.2062 9.03421 12.25 9.14845 12.25 9.27484V11.6373C12.25 11.8123 12.1917 11.9582 12.075 12.0748C11.9583 12.1915 11.8125 12.2498 11.6375 12.2498ZM10.5 5.83317L9.65417 5.0165L10.5875 4.08317H7.58333V2.9165H10.5875L9.68333 2.01234L10.5 1.1665L12.8333 3.529L10.5 5.83317Z",
    fill: "#07AA3F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneForwarded);
export default __webpack_public_path__ + "static/media/phone_forwarded.5602de8fa3af8ad0d0b2fdd6b3c4f8be.svg";
export { ForwardRef as ReactComponent };